import { useState } from 'react'
import './calculator-page.scss'
import api from '../api-client'
import { Section, LoanInformation, PaymentCalculator, SendReferralLink, LoanDisclosure } from '../components'
import { useAppState } from '../hooks'
import {
  errorToString,
  dollarsToNum,
  EquipmentType,
  LoanOptions as LoanOptsFilter,
} from '@oneethos/shared'
import { toast } from 'react-toastify'
import OrgStatusMessage from '../components/org-status-message'
import { EmbedCommercialScenarios } from '../components/embed-commercial-scenarios'

export const CalculatorPage = () => {
  const [formData, setFormData] = useState<any>({ 
    systemCost: '0', 
    loanAmount: '0',
    projectType: 'residential'
  })
  const [showCalculation, setShowCalculation] = useState<boolean>(false)
  const [financingTenant, setFinancingTenant] = useState(null)
  const [incentive, setIncentive] = useState()
  const [loadingCalculation, setLoadingCalculation] = useState(false)
  const { tenant: { config }, registration: { installer: { org } } } = useAppState()

  const isResidential = !['commercial', 'non-profit'].includes(formData.projectType)
  const isCommercial = formData.projectType === 'commercial'
  const isStorageOnly = formData.equipmentType === EquipmentType.StorageOnly

  if (org.isOnHold) {
    return <Section><OrgStatusMessage /></Section>
  }

  let loanOptions = []
  if (showCalculation) {
    const quotedProducts = financingTenant?.products?.length
      ? financingTenant.products
      : config.products
    loanOptions = LoanOptsFilter.for(
      formData,
      quotedProducts,
      financingTenant?.feesByProductType,
    )
  }

  return <div className="calculator-page">
    <PaymentCalculator
      formData={formData}
      financingTenant={financingTenant}
      isResidential={isResidential}
      onChange={data => {
        // change in address or system price requires recalculation
        setFinancingTenant(null)
        setShowCalculation(false)
        setIncentive(undefined)
        setFormData({
          ...data
        })
      }}
      showCalculation={showCalculation}
      incentive={incentive}
      loadingCalculation={loadingCalculation}
      onShowCalculation={() => {
        const query = new URLSearchParams({
          ...formData.installationAddress,
          projectType: formData.projectType,
          loanAmount: dollarsToNum(formData.loanAmount),
          equipmentType: formData.equipmentType,
        })

        setLoadingCalculation(true)
        api.get(`/tenant/for-project?${query.toString()}`).then(res => {
          if (isResidential && res.incentive) {
            setIncentive(res.incentive)
          }

          if (res.tenant) {
            setFinancingTenant(res.tenant)
          }

          setShowCalculation(true)
        }).catch(ex => toast.error(errorToString(ex)))
          .finally(() => setLoadingCalculation(false))
      }}
    />
    {showCalculation ? <>
      {incentive ? null :
        <LoanInformation
          isResidential={isResidential}
          isStorageOnly={isStorageOnly}
          loanOptions={loanOptions}
        />}
      {!isResidential ? <Section>
        <EmbedCommercialScenarios />
      </Section> : null}
      <Section>
        <SendReferralLink
          formData={formData}
          isResidential={isResidential}
          incentive={incentive}
          isCommercial={isCommercial}
        />
      </Section>
      <Section>
        <LoanDisclosure isResidential={isResidential} />
      </Section>
    </> : null}
  </div>
}

export default CalculatorPage
